import * as THREE from "three";
import {
  useRef,
} from "react";
import { getSeismicEventColor } from "./RTFOMapWithWellbore";

function defineSize(mag) {
  const sizeScalingFactor = 0.06;
  return (0.2 + Math.abs(mag) * sizeScalingFactor) || 0;
};

export default function RTFOWellbore3DSeismicityMesh({
  position,
  magnitude
}) {
  const meshRef = useRef();

  const geometry = new THREE.SphereGeometry(15, 32, 16);
  const material = new THREE.MeshStandardMaterial({ color: "#ffffff" });
  const sphere = new THREE.Mesh(geometry, material);
  sphere.position.set(new THREE.Vector3(10, 10, 10));

  return (
    <mesh ref={meshRef}
      position={position}
      // onClick={() => { console.log(`position: ${position}, magnitude: ${magnitude}, size: ${defineSize(magnitude)}`); }}
    >
      <sphereGeometry args={[defineSize(magnitude), 32, 32]} />
      <meshStandardMaterial color={getSeismicEventColor(magnitude)} />
    </mesh>
  );
};